import React from "react";
import { Quiz } from "components/quiz";

import "./app.css";

export const App = () => (
	<div className="app">
		<Quiz />
	</div>
);
